import React from 'react';
import ClassAssembly  from 'views/ClassAssembly12B';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;